import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://psymed.be";
const DEFAULT_IMAGE = "/images/og-image.jpg";
const BRAND = "Psymed";

function setTag(tag, keyAttr, key, valueAttr, value) {
  let el = document.head.querySelector(`${tag}[${keyAttr}="${key}"]`);
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute(keyAttr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(valueAttr, value);
}

const absolute = (url) => (url?.startsWith("http") ? url : `${SITE}${url || ""}`);

export default function Seo({ title, description, image, noindex = false }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!title) return;
    const fullTitle = title.includes(BRAND) ? title : `${title} | ${BRAND}`;
    const url = `${SITE}${pathname}`;
    const img = absolute(image || DEFAULT_IMAGE);
    document.title = fullTitle;
    setTag("meta", "name", "description", "content", description || "");
    setTag("meta", "name", "robots", "content", noindex ? "noindex, nofollow" : "index, follow");
    setTag("link", "rel", "canonical", "href", url);
    setTag("meta", "property", "og:title", "content", fullTitle);
    setTag("meta", "property", "og:description", "content", description || "");
    setTag("meta", "property", "og:url", "content", url);
    setTag("meta", "property", "og:image", "content", img);
    setTag("meta", "name", "twitter:title", "content", fullTitle);
    setTag("meta", "name", "twitter:description", "content", description || "");
    setTag("meta", "name", "twitter:image", "content", img);
  }, [title, description, image, noindex, pathname]);

  return null;
}
